"use client";

import { cn } from "@/lib/utils";
import getPriceInfoFromProduct, {
  PriceType,
} from "@/utils/elevate/getPriceInfoFromProduct";
import useTranslate from "@app/_hooks/useTranslate";
import { ComponentProps } from "react";
import Price from "../price/Price";
export default function ProductCardPrice({
  priceInfo,
  className,
  children,
  ...props
}: ComponentProps<"div"> & {
  priceInfo: ReturnType<typeof getPriceInfoFromProduct>;
}) {
  const t = useTranslate();
  return (
    <div
      className={cn("flex flex-row flex-wrap gap-x-1", className)}
      {...props}
    >
      {children}
      <Price
        prefix={priceInfo.fromPrice ? t("fromShortened") : undefined}
        price={priceInfo.price}
      />
      {(priceInfo.priceType === PriceType.campaign ||
        priceInfo.priceType === PriceType.pricematch) && (
        <Price
          className="text-gray-500 line-through"
          price={priceInfo.priceRrp ?? priceInfo.price}
        />
      )}
    </div>
  );
}

ProductCardPrice.displayName = "ProductCardPrice";
